import React, { useEffect } from 'react'
import Stores from 'Stores'
import { localisationMaster } from 'Localisation/Localisation'
import { translate as loc, dict } from 'Localisation'
import { classNames as cn } from 'helpers'
import asideModalStore from 'Stores/asideModalStore'
import { observer } from 'mobx-react'
import Flex from 'components/UI/Flex/Flex'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import InputFlagPhone from 'components/ContentBox/Global/InputPhone/InputFlagPhone/InputFlagPhone'
import DateTime from 'components/ContentBox/Global/DateTime/DateTime'
import './LocationForm.scss'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import ToggleCheckbox from 'components/UI/ToggleCheckbox/ToggleCheckbox'

const LocationsForm = (props) => {
  const { changeValue, values, check, changeValues, config } = asideModalStore

  useEffect(() => {
    if (Object.keys(values).length === 0 && config.modal_settings?.is_put) {
      changeValues(props.fix_data)
    }
  }, [])

  return (
    <div className='super-modal__form-column'>
      <div className='super-modal__form-field'>
        <FormLabel isRequired>
          {localisationMaster('table-row-title-1', 'company/programs')}:
        </FormLabel>
        <FormInput isError={check('name')}>
          <input
            type='text'
            placeholder={localisationMaster(
              'table-row-title-1',
              'company/programs',
            )}
            value={values.name || ''}
            onChange={(e) => changeValue(e.target.value, 'name')}
            className={cn({
              'super-modal__input': true,
              'super-modal__input--error': check('name'),
            })}
          />
        </FormInput>
      </div>
      <div className='super-modal__form-field'>
        <FormLabel isRequired>
          {localisationMaster(
            'input-placeholder-2',
            'company/locations',
            'add_location',
          )}
          :
        </FormLabel>
        <FormInput isError={check('address')}>
          <input
            type='text'
            placeholder={localisationMaster(
              'input-placeholder-2',
              'company/locations',
              'add_location',
            )}
            onChange={(e) => changeValue(e.target.value, 'address')}
            value={values.address || ''}
            className={cn({
              'super-modal__input': true,
              'super-modal__input--error': check('address'),
            })}
          />
        </FormInput>
        <div className='super-modal__toggle'>
          <Flex>
            <ToggleCheckbox
              label={localisationMaster(
                'checkbox-info',
                'company/locations',
                'add_location',
              )}
              checked={values.is_online}
              onChange={() => changeValue(!values.is_online, 'is_online')}
            />
          </Flex>
        </div>
      </div>
      <div className='locationForm__wrapper'>
        <div className='locationForm__field'>
          <FormLabel isRequired>
            {localisationMaster('name_4', 'company/locations', 'add_location')}:
          </FormLabel>
          <FormInput isError={check('home_phone')}>
            <InputFlagPhone
              value={values.home_phone}
              onChange={(val) => changeValue(val, 'home_phone')}
              error={check('home_phone')}
            />
          </FormInput>
        </div>
        <div className='locationForm__field'>
          <FormLabel isRequired>
            {localisationMaster('name_5', 'company/locations', 'add_location')}:
          </FormLabel>
          <FormInput isError={check('phone')}>
            <InputFlagPhone
              value={values.phone}
              onChange={(val) => changeValue(val, 'phone')}
              error={check('phone')}
            />
          </FormInput>
        </div>
      </div>
      <div className='super-modal__form-field'>
        <FormLabel isRequired>E-mail:</FormLabel>
        <FormInput isError={check('email')}>
          <input
            type='email'
            placeholder='E-mail'
            value={values.email || ''}
            onChange={(e) => changeValue(e.target.value, 'email')}
            className={cn({
              'super-modal__input': true,
              'super-modal__input--error': check('email'),
            })}
          />
        </FormInput>
      </div>
      <div className='locationForm__wrapper'>
        <div className='locationForm__field'>
          <FormLabel>
            {localisationMaster('text_22', 'company/locations')}:
          </FormLabel>

          <DateTime
            placeholder='9:00'
            start_at={values.start_at}
            finish_at={values.end_at}
            objectChangeHandler={(data, key) =>
              changeValue(data, key === 'finish_at' ? 'end_at' : 'start_at')
            }
          />
        </div>
        <div className='locationForm__field'>
          <FormLabel isRequired>
            {localisationMaster('text_23', 'company/locations')}:
          </FormLabel>

          <SelectCustom
            placeholder={localisationMaster('text_23', 'company/locations')}
            options={Stores.timeZones}
            onChange={(o) => changeValue(o.id, 'time_zone')}
            valueID={values?.time_zone}
            error={check('time_zone')}
          />
        </div>
      </div>
      <div>
        <Flex>
          <ToggleCheckbox
            label={loc(dict.company_locations.contact_test)}
            checked={values.only_online}
            onChange={() => changeValue(!values.only_online, 'only_online')}
          />
        </Flex>
      </div>
    </div>
  )
}

export default observer(LocationsForm)
